// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2094":"c40216d1","7282":"9d980484"}[chunkId] + ".chunk.css";
};